import { render, staticRenderFns } from "./NeedActionDone.vue?vue&type=template&id=1490029b&"
import script from "./NeedActionDone.vue?vue&type=script&lang=js&"
export * from "./NeedActionDone.vue?vue&type=script&lang=js&"
import style0 from "./NeedActionDone.vue?vue&type=style&index=0&id=1490029b&prod&lang=scss&"
import style1 from "./NeedActionDone.vue?vue&type=style&index=1&id=1490029b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports